import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const updateAlonePackage = createAction(ACTION.UPDATE_ALONE_PACKAGE.REQUEST, (params) => ({...params}));
export const createAlonePackage = createAction(ACTION.CREATE_ALONE_PACKAGE.REQUEST, (params) => (params));
export const resetError = createAction(ACTION.RESET_ERROR, (id, params) => ({id, params}));
export const clearState = createAction(ACTION.CLEAR_STATE, id => ({id}));